module.exports = __webpack_public_path__ + "static/media/call9.44a7d19e.png";